<template>
  <div class="edit__lab_test">
    <div class="vx-card p-6">
      <EditLabTestForm />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import EditLabTestForm from '@/views/lab-admin/components/EditLabTestForm.vue'
export default {
  name: 'EditLabTest',

  components: {
    EditLabTestForm
  },

  async mounted() {
    await this.get_lab_test_by_id()
  },

  methods: {
    ...mapActions('lab_test', { fetch_lab_test_by_id: 'getLabTestById' }),

    async get_lab_test_by_id() {
      try {
        await this.fetch_lab_test_by_id(this.$route.params.id)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  }
}
</script>

<style>
</style>